import React, { useState, useRef, useEffect, useContext } from "react";
import { ContextApi } from "../../../App";
import { v4 as uuidv4 } from "uuid";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { last } from "lodash";
import { If } from "react-condition";
import { formatDate } from "../../../utils/commonFunctions";
import {
  getTotalYearsOfExperience,
  toNumber,
} from "../../CandidateDashboard/utils/commonFunctions";

const extractFromAndTo = (input) => {
  const match = input.match(/(\d{2})\/(\d{2})\/(\d{4})/g);

  if (match && match.length === 2) {
    const [fromRaw, toRaw] = match;

    const formatDate = (dateStr) => {
      const [dd, mm, yyyy] = dateStr.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };

    const fromDate = formatDate(fromRaw);
    const toDate = formatDate(toRaw);
    return { fromDate, toDate };
  }
};

function ProfessionalExperience({
  onBlurHandler,
  isInputFieldTouched,
  data,
  defaultValue,
  isChild,
  approve,
  ocrDisabled,
  errorInputs,
}) {
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "professionalexperience",
    properties: {
      placeholder: "Enter here...",
      required: true,
    },
    filledOnly: 1,
    value: {},
  });

  const [comparison, setComparison] = useState({
    last_emp_designation: "",
    last_emp_from_date: "",
    last_emp_org: "",
    last_emp_to_date: "",
    last_emp_year_of_experience: "",
    last_emp_salary: "",
  });

  const [count, setCount] = useState(1);

  const handleKeyPress = (event) => {
    if (/[^a-zA-Z ]/.test(event.key)) {
      event.preventDefault();
    }
  };

  const handleKeyPressNumber = (event) => {
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    let obj = { ...data };
    if (data?.value) {
      if (Object.keys(data?.value).length !== 0) {
        setCount(obj.filledOnly);
      }
    }
    setElement((prev) => ({
      ...prev,
      ...obj,
    }));

    // if (isChild) {
    //   obj.properties.required = true;
    //   setElement((prev) => ({ ...prev, ...obj }));
    // }
  }, [data, isChild]);

  useEffect(() => {
    let _data = {};

    _data.last_emp = {};
    let _comp = {};

    if (data?.ocrData) {
      if (data?.ocrData?.experienceLetter) {
        const emp_designation =
          data?.ocrData?.experienceLetter?.designation || "";
        _data.last_emp.last_emp_designation = data?.ocrData?.experienceLetter
          ?.isActive
          ? emp_designation
          : data?.value?.last_emp?.last_emp_designation;
        _comp.last_emp_designation = emp_designation?.trim()?.toLowerCase();

        const emp_org = data?.ocrData?.experienceLetter?.company_name || "";
        _data.last_emp.last_emp_org = data?.ocrData?.experienceLetter?.isActive
          ? emp_org
          : data?.value?.last_emp?.last_emp_org;
        _comp.last_emp_org = emp_org?.trim()?.toLowerCase();

        const { fromDate, toDate } =
          extractFromAndTo(
            data?.ocrData?.experienceLetter?.employment_duration || ""
          ) || {};
        _data.last_emp.last_emp_from_date = data?.ocrData?.experienceLetter
          ?.isActive
          ? fromDate || ""
          : data?.value?.last_emp?.last_emp_from_date;
        _comp.last_emp_from_date = (fromDate || "")?.trim()?.toLowerCase();

        _data.last_emp.last_emp_to_date = data?.ocrData?.experienceLetter
          ?.isActive
          ? toDate || ""
          : data?.value?.last_emp?.last_emp_to_date;
        _comp.last_emp_to_date = (toDate || "")?.trim()?.toLowerCase();

        const year_of_exp =
          getTotalYearsOfExperience(
            data?.ocrData?.experienceLetter?.total_exp_in_years || "",
            true
          ) || "";
        _data.last_emp.last_emp_year_of_experience = data?.ocrData
          ?.experienceLetter?.isActive
          ? year_of_exp || ""
          : data?.value?.last_emp?.last_emp_year_of_experience;
        _comp.last_emp_year_of_experience = year_of_exp;
      }

      if (data?.ocrData?.offerLetter) {
        if (data?.ocrData?.offerLetter?.ctc) {
          const emp_sal = toNumber(data?.ocrData?.offerLetter?.ctc);
          _data.last_emp.last_emp_salary = data?.ocrData?.offerLetter
            ?.isActive
            ? emp_sal || 0
            : data?.value?.last_emp?.last_emp_salary;
          _comp.last_emp_salary = emp_sal || 0;
        }
      }
    }

    
    setComparison((prev) => ({
      ...prev,
      ..._comp,
    }));
    
    const last_ = {
      ...data?.value?.last_emp || {},
      ..._data?.last_emp || {}, 
    }

    setElement((prev) => ({
      ...prev,
      ...data,
      value: {
        ...data?.value || {},
        last_emp : last_
      },
    }));
  }, [data?.ocrData]);

  const changeHandler = (e) => {
    if (isInputFieldTouched) {
      isInputFieldTouched();
    }
    const label = e.target.name.slice(0, e.target.name.indexOf("emp") + 3);
    if ("last_emp" === label) {
      setElement({
        ...element,
        value: {
          ...element.value,
          last_emp: {
            ...element.value?.last_emp,
            [e.target.name]: e.target.value,
          },
        },
        comparison: {
          ...(element?.comparison || {}),
          ...(comparison.hasOwnProperty(e.target.name)
            ? {
                [e.target.name]:
                  comparison[e.target.name] !==
                  String(e.target.value)?.trim().toLowerCase()
                    ? true
                    : false,
              }
            : {}),
        },
      });
    } else if (label === "last_to_last_emp") {
      setElement({
        ...element,
        value: {
          ...element.value,
          last_to_last_emp: {
            ...element.value?.last_to_last_emp,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (label === "last_to_second_last_emp") {
      setElement({
        ...element,
        value: {
          ...element.value,
          last_to_second_last_emp: {
            ...element.value?.last_to_second_last_emp,
            [e.target.name]: e.target.value,
          },
        },
      });
    }
  };
  const deleteObjectKey = (key) => {
    const obj = { ...element };
    if (obj?.value) {
      delete obj.value[key];
    }
    setElement(obj);
  };

  const foundError = errorInputs?.find(
    (ele) => ele?.label === "professionalexperience"
  )?.value;

  const { last_emp, last_to_last_emp, last_to_second_last_emp } =
    foundError || {};

  return (
    <div
      className="form-group col-md-12 form-builder-element mb-3 form-view"
      data={JSON.stringify(element)}
    >
      <div className="form-group">
        <div className="row">
          <div className="col-12" style={{ position: "relative" }}>
            <h5>Employment Tenure (Last Employer)</h5>
          </div>
          <div className="col-12 mb-2">
            <label htmlFor="">
              Designation at Last Employer
              <If test={element.properties.required === true}>
                <span style={{ color: "red" }}>*</span>
              </If>{" "}
            </label>
            <input
              {...{
                className: `form-control ${
                  last_emp?.last_emp_designation ? "border border-danger" : ""
                }`,
                type: "text",
              }}
              onChange={changeHandler}
              onInput={changeHandler}
              onKeyPress={handleKeyPress}
              name="last_emp_designation"
              placeholder={element.properties.placeholder}
              disabled={approve || ocrDisabled}
              defaultValue={element.value?.last_emp?.last_emp_designation}
            />
            {last_emp?.last_emp_designation && (
              <p className="text-danger">{last_emp?.last_emp_designation}</p>
            )}
          </div>
          <div className="col-12 mb-2">
            <label htmlFor="">
              Organization Name and Location
              <If test={element.properties.required === true}>
                <span style={{ color: "red" }}>*</span>
              </If>{" "}
            </label>
            <input
              {...{
                className: `form-control ${
                  last_emp?.last_emp_org ? "border border-danger" : ""
                }`,
                type: "text",
              }}
              onChange={changeHandler}
              onInput={changeHandler}
              // onKeyPress={handleKeyPress}
              name="last_emp_org"
              placeholder={element.properties.placeholder}
              disabled={approve || ocrDisabled}
              defaultValue={element.value?.last_emp?.last_emp_org}
            />
            {last_emp?.last_emp_org && (
              <p className="text-danger">{last_emp?.last_emp_org}</p>
            )}
          </div>
          <div className="col-12 mb-2">
            <label htmlFor="">
              Employment From Date (dd/mm/yy)
              <If test={element.properties.required === true}>
                <span style={{ color: "red" }}>*</span>
              </If>{" "}
            </label>
            <input
              {...{
                className: `form-control ${
                  last_emp?.last_emp_from_date ? "border border-danger" : ""
                }`,
                type: "date",
              }}
              onChange={changeHandler}
              onInput={changeHandler}
              name="last_emp_from_date"
              max={formatDate(new Date())}
              disabled={approve || ocrDisabled}
              defaultValue={element.value?.last_emp?.last_emp_from_date}
            />
            {last_emp?.last_emp_from_date && (
              <p className="text-danger">{last_emp?.last_emp_from_date}</p>
            )}
          </div>
          <div className="col-12 mb-2">
            <label htmlFor="">
              Employment To Date (dd/mm/yy)
              <If test={element.properties.required === true}>
                <span style={{ color: "red" }}>*</span>
              </If>
            </label>
            <input
              {...{
                className: `form-control ${
                  last_emp?.last_emp_to_date ? "border border-danger" : ""
                }`,
                type: "date",
              }}
              name="last_emp_to_date"
              onChange={changeHandler}
              onInput={changeHandler}
              disabled={approve || ocrDisabled}
              max={formatDate(new Date())}
              defaultValue={element.value?.last_emp?.last_emp_to_date}
            />
            {last_emp?.last_emp_to_date && (
              <p className="text-danger">{last_emp?.last_emp_to_date}</p>
            )}
          </div>
          <div className="col-12 mb-2">
            <label htmlFor="">
              Total years of experience
              <If test={element.properties.required === true}>
                <span style={{ color: "red" }}>*</span>
              </If>
            </label>
            <input
              {...{
                className: `form-control ${
                  last_emp?.last_emp_year_of_experience
                    ? "border border-danger"
                    : ""
                }`,
                type: "number",
              }}
              placeholder={element.properties.placeholder}
              onKeyPress={handleKeyPressNumber}
              onChange={changeHandler}
              onInput={changeHandler}
              min={0}
              name="last_emp_year_of_experience"
              disabled={approve || ocrDisabled}
              defaultValue={
                element.value?.last_emp?.last_emp_year_of_experience
              }
            />
            {last_emp?.last_emp_year_of_experience && (
              <p className="text-danger">
                {last_emp?.last_emp_year_of_experience}
              </p>
            )}
          </div>
          <div className="col-12 mb-2">
            <label htmlFor="">
              Reason for Leaving
              <If test={element.properties.required === true}>
                <span style={{ color: "red" }}>*</span>
              </If>
            </label>
            <input
              {...{
                className: `form-control ${
                  last_emp?.last_emp_reason_for_leaving
                    ? "border border-danger"
                    : ""
                }`,
                type: "text",
              }}
              placeholder={element.properties.placeholder}
              name="last_emp_reason_for_leaving"
              onChange={changeHandler}
              onInput={changeHandler}
              onKeyPress={handleKeyPress}
              disabled={approve || ocrDisabled}
              defaultValue={
                element.value?.last_emp?.last_emp_reason_for_leaving
              }
            />
            {last_emp?.last_emp_reason_for_leaving && (
              <p className="text-danger">
                {last_emp?.last_emp_reason_for_leaving}
              </p>
            )}
          </div>
          <div className="col-12 mb-2">
            <label htmlFor="">
              Salary (per annum)
              <If test={element.properties.required === true}>
                <span style={{ color: "red" }}>*</span>
              </If>
            </label>
            <input
              {...{
                className: `form-control ${
                  last_emp?.last_emp_salary ? "border border-danger" : ""
                }`,
                type: "number",
              }}
              placeholder={element.properties.placeholder}
              onKeyPress={handleKeyPressNumber}
              onChange={changeHandler}
              onInput={changeHandler}
              min={0}
              name="last_emp_salary"
              disabled={approve || ocrDisabled}
              defaultValue={element.value?.last_emp?.last_emp_salary}
            />
            {last_emp?.last_emp_salary && (
              <p className="text-danger">{last_emp?.last_emp_salary}</p>
            )}
          </div>
          <div className="col-12" style={{ position: "relative" }}>
            <h5>Supervisor/ HR Manager Details</h5>
          </div>
          <div className="col-12 mb-2">
            <label htmlFor="">
              Name
              <If test={element.properties.required === true}>
                <span style={{ color: "red" }}>*</span>
              </If>{" "}
            </label>
            <input
              {...{
                className: `form-control ${
                  last_emp?.last_emp_supervisor_name
                    ? "border border-danger"
                    : ""
                }`,
                type: "text",
              }}
              onChange={changeHandler}
              onInput={changeHandler}
              onKeyPress={handleKeyPress}
              name="last_emp_supervisor_name"
              placeholder={element.properties.placeholder}
              disabled={approve || ocrDisabled}
              defaultValue={element.value?.last_emp?.last_emp_supervisor_name}
            />
            {last_emp?.last_emp_supervisor_name && (
              <p className="text-danger">
                {last_emp?.last_emp_supervisor_name}
              </p>
            )}
          </div>
          <div className="col-12 mb-2">
            <label htmlFor="">
              Designation
              <If test={element.properties.required === true}>
                <span style={{ color: "red" }}>*</span>
              </If>{" "}
            </label>
            <input
              {...{
                className: `form-control ${
                  last_emp?.last_emp_supervisor_designation
                    ? "border border-danger"
                    : ""
                }`,
                type: "text",
              }}
              onChange={changeHandler}
              onInput={changeHandler}
              onKeyPress={handleKeyPress}
              name="last_emp_supervisor_designation"
              placeholder={element.properties.placeholder}
              disabled={approve || ocrDisabled}
              defaultValue={
                element.value?.last_emp?.last_emp_supervisor_designation
              }
            />
            {last_emp?.last_emp_supervisor_designation && (
              <p className="text-danger">
                {last_emp?.last_emp_supervisor_designation}
              </p>
            )}
          </div>
          <div className="col-12 mb-2">
            <label htmlFor="">
              Mobile No.
              <If test={element.properties.required === true}>
                <span style={{ color: "red" }}>*</span>
              </If>{" "}
            </label>
            <input
              {...{
                className: `form-control ${
                  last_emp?.last_emp_supervisor_mobile_no
                    ? "border border-danger"
                    : ""
                }`,
                type: "number",
              }}
              onChange={changeHandler}
              onInput={changeHandler}
              onKeyPress={handleKeyPressNumber}
              name="last_emp_supervisor_mobile_no"
              placeholder={element.properties.placeholder}
              disabled={approve || ocrDisabled}
              defaultValue={
                element.value?.last_emp?.last_emp_supervisor_mobile_no
              }
            />
            {last_emp?.last_emp_supervisor_mobile_no && (
              <p className="text-danger">
                {last_emp?.last_emp_supervisor_mobile_no}
              </p>
            )}
          </div>
        </div>
        {(count >= 2 || element.filledOnly >= 2) && (
          <>
            <div className="row">
              <div className="col-12" style={{ position: "relative" }}>
                <h5>Employment Tenure (Second Last employer)</h5>
                {approve !== true && (
                  <label
                    onClick={(e) => {
                      if (count > 1 && approve !== true) {
                        setCount(count - 1);
                        deleteObjectKey("last_to_last_emp");
                        setElement({
                          ...element,
                          filledOnly: count - 1,
                        });
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: 0,
                      right: 12,
                    }}
                  >
                    - Remove
                  </label>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Designation at Second last employer
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>{" "}
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_last_emp?.last_to_last_emp_designation
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "text",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPress}
                  name="last_to_last_emp_designation"
                  placeholder={element.properties.placeholder}
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_last_emp
                      ?.last_to_last_emp_designation
                  }
                />
                {last_to_last_emp?.last_to_last_emp_designation && (
                  <p className="text-danger">
                    {last_to_last_emp?.last_to_last_emp_designation}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Organization Name and Location
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>{" "}
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_last_emp?.last_to_last_emp_org
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "text",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  // onKeyPress={handleKeyPress}
                  name="last_to_last_emp_org"
                  disabled={approve}
                  placeholder={element.properties.placeholder}
                  defaultValue={
                    element.value?.last_to_last_emp?.last_to_last_emp_org
                  }
                />
                {last_to_last_emp?.last_to_last_emp_org && (
                  <p className="text-danger">
                    {last_to_last_emp?.last_to_last_emp_org}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Employment From Date (dd/mm/yy)
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_last_emp?.last_to_last_emp_from_date
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "date",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  name="last_to_last_emp_from_date"
                  disabled={approve}
                  max={formatDate(new Date())}
                  defaultValue={
                    element.value?.last_to_last_emp?.last_to_last_emp_from_date
                  }
                />
                {last_to_last_emp?.last_to_last_emp_from_date && (
                  <p className="text-danger">
                    {last_to_last_emp?.last_to_last_emp_from_date}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Employment To Date (dd/mm/yy)
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_last_emp?.last_to_last_emp_to_date
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "date",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  name="last_to_last_emp_to_date"
                  disabled={approve}
                  max={formatDate(new Date())}
                  defaultValue={
                    element.value?.last_to_last_emp?.last_to_last_emp_to_date
                  }
                />
                {last_to_last_emp?.last_to_last_emp_to_date && (
                  <p className="text-danger">
                    {last_to_last_emp?.last_to_last_emp_to_date}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Total years of experience
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_last_emp?.last_to_last_emp_year_of_experience
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "number",
                  }}
                  placeholder={element.properties.placeholder}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPressNumber}
                  min={0}
                  disabled={approve}
                  name="last_to_last_emp_year_of_experience"
                  defaultValue={
                    element.value?.last_to_last_emp
                      ?.last_to_last_emp_year_of_experience
                  }
                />
                {last_to_last_emp?.last_to_last_emp_year_of_experience && (
                  <p className="text-danger">
                    {last_to_last_emp?.last_to_last_emp_year_of_experience}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Reason for Leaving
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_last_emp?.last_to_last_emp_reason_for_leaving
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "text",
                  }}
                  placeholder={element.properties.placeholder}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPress}
                  disabled={approve}
                  name="last_to_last_emp_reason_for_leaving"
                  defaultValue={
                    element.value?.last_to_last_emp
                      ?.last_to_last_emp_reason_for_leaving
                  }
                />
                {last_to_last_emp?.last_to_last_emp_reason_for_leaving && (
                  <p className="text-danger">
                    {last_to_last_emp?.last_to_last_emp_reason_for_leaving}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Salary (per annum)
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_last_emp?.last_to_last_emp_salary
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "number",
                  }}
                  placeholder={element.properties.placeholder}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPressNumber}
                  min={0}
                  disabled={approve}
                  name="last_to_last_emp_salary"
                  defaultValue={
                    element.value?.last_to_last_emp?.last_to_last_emp_salary
                  }
                />
                {last_to_last_emp?.last_to_last_emp_salary && (
                  <p className="text-danger">
                    {last_to_last_emp?.last_to_last_emp_salary}
                  </p>
                )}
              </div>
              <div className="col-12" style={{ position: "relative" }}>
                <h5>Supervisor/ HR Manager Details</h5>
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Name
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>{" "}
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_last_emp?.last_to_last_emp_supervisor_name
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "text",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPress}
                  name="last_to_last_emp_supervisor_name"
                  placeholder={element.properties.placeholder}
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_last_emp
                      ?.last_to_last_emp_supervisor_name
                  }
                />
                {last_to_last_emp?.last_to_last_emp_supervisor_name && (
                  <p className="text-danger">
                    {last_to_last_emp?.last_to_last_emp_supervisor_name}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Designation
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>{" "}
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_last_emp?.last_to_last_emp_supervisor_designation
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "text",
                  }}
                  onKeyPress={handleKeyPress}
                  onInput={changeHandler}
                  onChange={changeHandler}
                  name="last_to_last_emp_supervisor_designation"
                  placeholder={element.properties.placeholder}
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_last_emp
                      ?.last_to_last_emp_supervisor_designation
                  }
                />
                {last_to_last_emp?.last_to_last_emp_supervisor_designation && (
                  <p className="text-danger">
                    {last_to_last_emp?.last_to_last_emp_supervisor_designation}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Mobile No.
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>{" "}
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_last_emp?.last_to_last_emp_supervisor_mobile_no
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "number",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPressNumber}
                  name="last_to_last_emp_supervisor_mobile_no"
                  placeholder={element.properties.placeholder}
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_last_emp
                      ?.last_to_last_emp_supervisor_mobile_no
                  }
                />
                {last_to_last_emp?.last_to_last_emp_supervisor_mobile_no && (
                  <p className="text-danger">
                    {last_to_last_emp?.last_to_last_emp_supervisor_mobile_no}
                  </p>
                )}
              </div>
            </div>
          </>
        )}
        {(count === 3 || element.filledOnly === 3) && (
          <>
            <div className="row">
              <div className="col-12" style={{ position: "relative" }}>
                <h5>Employment Tenure (Third Last Employer)</h5>
                {approve !== true && (
                  <label
                    onClick={(e) => {
                      if (count > 1 && approve !== true) {
                        setCount(count - 1);
                        deleteObjectKey("last_to_second_last_emp");
                        setElement({
                          ...element,
                          filledOnly: count - 1,
                        });
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: 0,
                      right: 12,
                    }}
                  >
                    - Remove
                  </label>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Designation at third last employer
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>{" "}
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_second_last_emp?.last_to_second_last_emp_designation
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "text",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPress}
                  name="last_to_second_last_emp_designation"
                  placeholder={element.properties.placeholder}
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_second_last_emp
                      ?.last_to_second_last_emp_designation
                  }
                />
                {last_to_second_last_emp?.last_to_second_last_emp_designation && (
                  <p className="text-danger">
                    {
                      last_to_second_last_emp?.last_to_second_last_emp_designation
                    }
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Organization Name and Location
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>{" "}
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_second_last_emp?.last_to_second_last_emp_org
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "text",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  // onKeyPress={handleKeyPress}
                  name="last_to_second_last_emp_org"
                  placeholder={element.properties.placeholder}
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_second_last_emp
                      ?.last_to_second_last_emp_org
                  }
                />
                {last_to_second_last_emp?.last_to_second_last_emp_org && (
                  <p className="text-danger">
                    {last_to_second_last_emp?.last_to_second_last_emp_org}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Employment From Date (dd/mm/yy)
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_second_last_emp?.last_to_second_last_emp_from_date
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "date",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  max={formatDate(new Date())}
                  name="last_to_second_last_emp_from_date"
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_second_last_emp
                      ?.last_to_second_last_emp_from_date
                  }
                />
                {last_to_second_last_emp?.last_to_second_last_emp_from_date && (
                  <p className="text-danger">
                    {last_to_second_last_emp?.last_to_second_last_emp_from_date}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Employment To Date (dd/mm/yy)
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_second_last_emp?.last_to_second_last_emp_to_date
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "date",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  name="last_to_second_last_emp_to_date"
                  disabled={approve}
                  max={formatDate(new Date())}
                  defaultValue={
                    element.value?.last_to_second_last_emp
                      ?.last_to_second_last_emp_to_date
                  }
                />
                {last_to_second_last_emp?.last_to_second_last_emp_to_date && (
                  <p className="text-danger">
                    {last_to_second_last_emp?.last_to_second_last_emp_to_date}
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Total years of experience
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_second_last_emp?.last_to_second_last_emp_year_of_experience
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "number",
                  }}
                  placeholder={element.properties.placeholder}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPressNumber}
                  min={0}
                  name="last_to_second_last_emp_year_of_experience"
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_second_last_emp
                      ?.last_to_second_last_emp_year_of_experience
                  }
                />
                {last_to_second_last_emp?.last_to_second_last_emp_year_of_experience && (
                  <p className="text-danger">
                    {
                      last_to_second_last_emp?.last_to_second_last_emp_year_of_experience
                    }
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Reason for Leaving
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_second_last_emp?.last_to_second_last_emp_reason_for_leaving
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "text",
                  }}
                  placeholder={element.properties.placeholder}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPress}
                  name="last_to_second_last_emp_reason_for_leaving"
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_second_last_emp
                      ?.last_to_second_last_emp_reason_for_leaving
                  }
                />
                {last_to_second_last_emp?.last_to_second_last_emp_reason_for_leaving && (
                  <p className="text-danger">
                    {
                      last_to_second_last_emp?.last_to_second_last_emp_reason_for_leaving
                    }
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Salary (per annum)
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_second_last_emp?.last_to_second_last_emp_salary
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "number",
                  }}
                  placeholder={element.properties.placeholder}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPressNumber}
                  min={0}
                  name="last_to_second_last_emp_salary"
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_second_last_emp
                      ?.last_to_second_last_emp_salary
                  }
                />
                {last_to_second_last_emp?.last_to_second_last_emp_salary && (
                  <p className="text-danger">
                    {last_to_second_last_emp?.last_to_second_last_emp_salary}
                  </p>
                )}
              </div>
              <div className="col-12" style={{ position: "relative" }}>
                <h5>Supervisor/ HR Manager Details</h5>
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Name
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>{" "}
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_second_last_emp?.last_to_second_last_emp_supervisor_name
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "text",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPress}
                  name="last_to_second_last_emp_supervisor_name"
                  placeholder={element.properties.placeholder}
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_second_last_emp
                      ?.last_to_second_last_emp_supervisor_name
                  }
                />
                {last_to_second_last_emp?.last_to_second_last_emp_supervisor_name && (
                  <p className="text-danger">
                    {
                      last_to_second_last_emp?.last_to_second_last_emp_supervisor_name
                    }
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Designation
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>{" "}
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_second_last_emp?.last_to_second_last_emp_supervisor_designation
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "text",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPress}
                  name="last_to_second_last_emp_supervisor_designation"
                  placeholder={element.properties.placeholder}
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_second_last_emp
                      ?.last_to_second_last_emp_supervisor_designation
                  }
                />
                {last_to_second_last_emp?.last_to_second_last_emp_supervisor_designation && (
                  <p className="text-danger">
                    {
                      last_to_second_last_emp?.last_to_second_last_emp_supervisor_designation
                    }
                  </p>
                )}
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="">
                  Mobile No.
                  <If test={element.properties.required === true}>
                    <span style={{ color: "red" }}>*</span>
                  </If>{" "}
                </label>
                <input
                  {...{
                    className: `form-control ${
                      last_to_second_last_emp?.last_to_second_last_emp_supervisor_mobile_no
                        ? "border border-danger"
                        : ""
                    }`,
                    type: "number",
                  }}
                  onChange={changeHandler}
                  onInput={changeHandler}
                  onKeyPress={handleKeyPressNumber}
                  name="last_to_second_last_emp_supervisor_mobile_no"
                  placeholder={element.properties.placeholder}
                  disabled={approve}
                  defaultValue={
                    element.value?.last_to_second_last_emp
                      ?.last_to_second_last_emp_supervisor_mobile_no
                  }
                />
                {last_to_second_last_emp?.last_to_second_last_emp_supervisor_mobile_no && (
                  <p className="text-danger">
                    {
                      last_to_second_last_emp?.last_to_second_last_emp_supervisor_mobile_no
                    }
                  </p>
                )}
              </div>
            </div>
          </>
        )}
        {Number(element.properties?.count) > count && approve !== true && (
          <label
            onClick={(e) => {
              if (
                Number(element.properties?.count) > count &&
                approve !== true
              ) {
                setCount(count + 1);
                setElement({
                  ...element,
                  filledOnly: count + 1,
                });
              }
            }}
            style={{
              textAlign: "right",
              display: "inline-block",
              width: "100%",
              cursor: "pointer",
            }}
          >
            + Add more
          </label>
        )}
      </div>
    </div>
  );
}

export default ProfessionalExperience;
